'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _regeneratorRuntime = require('@babel/runtime/regenerator');
var process = require('process');
var fetch = require('isomorphic-fetch');
var cache$1 = require('./cache.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var fetch__default = /*#__PURE__*/_interopDefaultLegacy(fetch);

var cache = cache$1.createCache();
var WARNING_DURATION_THRESHOLD_MS = 1000;
var NANO_SECONDS_IN_MILLISECOND = 1000000n;
var probeStatus = {
  Ok: 'Ok',
  Warning: 'Warning',
  Error: 'Error'
};
/**
 *
 * @param {BigInt} start
 * @param {BigInt} end
 * @returns {Number} - difference in milliseconds
 */

var getDuration = function getDuration(start, end) {
  return Number((end.valueOf() - start.valueOf()) / NANO_SECONDS_IN_MILLISECOND);
};
/**
 *
 * @param {Object} options
 * @param {string} options.name
 * @param {string} options.url
 * @param {Record<string, string>} options.headers
 * @returns
 */


var dependencyHealthCheck = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(_ref) {
    var name, url, headers, start, res, end, duration, contentType, isJsonResponse, data, _status, _message, dependency, isVerySlow, status, message, _err$message, _end, _duration, _status2, _message2, _data;

    return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            name = _ref.name, url = _ref.url, headers = _ref.headers;
            start = process.hrtime.bigint();
            _context.prev = 2;
            _context.next = 5;
            return fetch__default["default"](url, {
              headers: headers
            });

          case 5:
            res = _context.sent;
            end = process.hrtime.bigint();
            duration = getDuration(start, end);

            if (res.ok) {
              _context.next = 25;
              break;
            }

            contentType = res.headers.get('Content-Type') || '';
            isJsonResponse = /application\/json/.test(contentType);
            data = {};

            if (!isJsonResponse) {
              _context.next = 18;
              break;
            }

            _context.next = 15;
            return res.json()["catch"](function () {
              return {};
            });

          case 15:
            data = _context.sent;
            _context.next = 21;
            break;

          case 18:
            _context.next = 20;
            return res.text()["catch"](function () {
              return '';
            });

          case 20:
            data.text = _context.sent;

          case 21:
            _status = probeStatus.Error;
            _message = "Status: ".concat(res.status, ", message: ").concat(res.statusText);
            dependency = {
              name: name,
              status: _status,
              duration: duration,
              message: _message,
              data: data
            };
            return _context.abrupt("return", dependency);

          case 25:
            isVerySlow = duration >= WARNING_DURATION_THRESHOLD_MS;
            status = isVerySlow ? probeStatus.Warning : probeStatus.Ok;
            message = isVerySlow ? 'response time slow' : 'response time ok';
            return _context.abrupt("return", {
              name: name,
              status: status,
              duration: duration,
              message: message,
              data: {}
            });

          case 31:
            _context.prev = 31;
            _context.t0 = _context["catch"](2);
            _end = process.hrtime.bigint();
            _duration = getDuration(start, _end);
            _status2 = probeStatus.Error;
            _message2 = (_err$message = _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) !== null && _err$message !== void 0 ? _err$message : 'Probe check failed, unkwon reason';
            _data = JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0));
            return _context.abrupt("return", {
              name: name,
              status: _status2,
              duration: _duration,
              message: _message2,
              data: _data
            });

          case 39:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 31]]);
  }));

  return function dependencyHealthCheck(_x) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 *
 * @typedef {Object} ProbeConfig
 * @property {string} url
 * @property {string} name
 * @property {Record<string, string>} [headers]
 *
 *
 * @typedef {Object} Dependency
 * @property {string} status
 * @property {string} name
 * @property {number} duration
 * @property {string} message
 * @property {any} data
 *
 *
 * @param {ProbeConfig[]} config
 * @returns {Promise<{status: string, dependencies: Dependency[]}>} result
 */


var probeCheck = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee2(config) {
    var dependencies, statuses, status;
    return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all(config.map(dependencyHealthCheck));

          case 2:
            dependencies = _context2.sent;
            statuses = dependencies.map(function (d) {
              return d.status;
            });
            status = 'Ok';

            if (statuses.includes('Error')) {
              status = 'Error';
            } else if (statuses.includes('Warning')) {
              status = 'Warning';
            }

            return _context2.abrupt("return", {
              status: status,
              dependencies: dependencies
            });

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function probeCheck(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
var PROBE_CACHE_KEY = 'probe';
var PROBE_CACHE_TTL = 1 * 60 * 1000;
/**
 *
 *
 * Example:
 * ```js
 * const dependencies = [
 *  { name: 'bookinghub', url: bookingHubUrl },
 *  { name: 'TokenWS', url: tokenApi },
 *  { name: 'CrmApi', url: `${crmApiProxy}/customerapi/`, headers: { 'Ocp-Apim-Subscription-Key': apimKey } }
 * ]
 * app.get('/probe', (req, res) => probeCheck(req, res, dependencies));
 * ```
 *
 * @param {import('express').Request} _req
 * @param {import('express').Response} res
 * @param {Dependency[]} dependencies
 */

var probe = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee3(_req, res, dependencies) {
    var cachedResult, result;
    return _regeneratorRuntime__default["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            // We cache the results of the probe check for one minute, since Dynatrace calls
            // this endpoint like once a second, and we do not want to DDos our dependencies 🙄
            cachedResult = cache.get(PROBE_CACHE_KEY);

            if (!cachedResult) {
              _context3.next = 5;
              break;
            }

            if ((cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.status) === 'Error') {
              res.status(500).json(cachedResult);
            } else {
              res.status(200).json(cachedResult);
            }

            return _context3.abrupt("return");

          case 5:
            _context3.next = 7;
            return probeCheck(dependencies);

          case 7:
            result = _context3.sent;
            cache.set({
              name: PROBE_CACHE_KEY,
              data: result,
              ttl: PROBE_CACHE_TTL
            });

            if ((result === null || result === void 0 ? void 0 : result.status) === 'Error') {
              res.status(500).json(result);
            } else {
              res.status(200).json(result);
            }

            _context3.next = 15;
            break;

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](0);
            res.status(500).json({
              message: 'Internal Server Error'
            });

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 12]]);
  }));

  return function probe(_x3, _x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

exports.probe = probe;
exports.probeCheck = probeCheck;
//# sourceMappingURL=probe.js.map
